import { fetchApi } from './client';

/** Overall report states (mirrors VGS `OsintReportStatus`). */
export type OsintReportStatus =
    | 'NOT_STARTED'
    | 'PROCESSING'
    | 'COMPLETED'
    | 'PARTIAL_COMPLETED'
    | 'ERROR'
    | 'CANCELLED';

/** One report section. `content` is polymorphic, discriminated by `sectionType`. */
export interface OsintReportSection {
    sectionType: string;
    /** `PROCESSING` | `SUCCESS` | `ERROR` | `PARTIAL`. */
    reportSectionStatus: string;
    content: unknown;
}

/** An OSINT report and its sections, as VGS returns it (camelCase, ISO dates). */
export interface OsintReport {
    id: number;
    catalogProductId: number;
    reportStatus: OsintReportStatus;
    source: string;
    createdAt: string;
    completedAt: string | null;
    sections: OsintReportSection[];
}

/**
 * Latest finished (COMPLETED / PARTIAL_COMPLETED) OSINT report for a vendor,
 * keyed on its numeric candidate id (= catalog product id, F3). `null` when
 * the vendor has no finished report.
 */
export async function getLatestOsintReport(candidateId: number): Promise<OsintReport | null> {
    return fetchApi<OsintReport | null>(`/api/osint/reports/latest/${String(candidateId)}`);
}
